import 'styled-components';
import { Color } from './Color';
export class Theme {
    id;
    name;
    foreground;
    background;
    body;
    primary;
    secondary;
    success;
    warning;
    danger;
    black;
    white;
    gray;
    blue;
    cyan;
    seafoam;
    green;
    orange;
    red;
    pink;
    purple;
    colors;
    style;
    constructor(props) {
        const foreground = props.foreground;
        const background = props.background;
        const body = props.body;
        // Identifiers
        this.id = props.name.toLowerCase();
        this.name = props.name;
        // Main
        this.foreground = foreground;
        this.background = background;
        this.body = body;
        // Colors
        this.primary = new Color({
            color: props.primary,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.secondary = new Color({
            color: props.secondary,
            themeForeground: foreground,
            themeBackground: background,
            saturation: props.secondarySaturation ?? 0,
        });
        this.success = new Color({
            color: props.success,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.warning = new Color({
            color: props.warning,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.danger = new Color({
            color: props.danger,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.black = new Color({
            color: props.black,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.white = new Color({
            color: props.white,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.gray = new Color({
            color: props.gray,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.blue = new Color({
            color: props.blue,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.cyan = new Color({
            color: props.cyan,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.seafoam = new Color({
            color: props.seafoam,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.green = new Color({
            color: props.green,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.orange = new Color({
            color: props.orange,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.red = new Color({
            color: props.red,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.pink = new Color({
            color: props.pink,
            themeForeground: foreground,
            themeBackground: background,
        });
        this.purple = new Color({
            color: props.purple,
            themeForeground: foreground,
            themeBackground: background,
        });
        const colorObject = {};
        for (const colorKey in props.colors) {
            if (props.colors.hasOwnProperty(colorKey)) {
                colorObject[colorKey] = new Color({
                    color: props.colors[colorKey],
                    themeForeground: foreground,
                    themeBackground: background,
                });
            }
        }
        this.colors = colorObject;
        const styleObject = {};
        for (const styleKey in props.style) {
            if (props.style.hasOwnProperty(styleKey)) {
                styleObject[styleKey] = this.themeVar(props.style[styleKey]);
            }
        }
        this.style = styleObject;
    }
    themeVar(value) {
        if (value.startsWith('Color:')) {
            const vars = value
                .replace('Color:', '')
                .trim()
                .split(',')
                .map((v) => v.trim());
            const base = typeof this?.colors[vars[0]] !== 'undefined' ? this?.colors[vars[0]] : this[vars[0]];
            if (typeof vars[2] === 'undefined' && typeof vars[1] === 'undefined' && typeof vars[0] !== 'undefined') {
                return base;
            }
            if (typeof vars[2] === 'undefined' && typeof vars[1] !== 'undefined' && typeof vars[0] !== 'undefined') {
                return base[vars[1]];
            }
            const args = [...vars];
            delete args[0];
            delete args[1];
            return base[vars[1]](...args.filter((n) => typeof n !== 'undefined' && n !== null).map((n) => parseInt(n, 10)));
        }
        return value;
    }
}
//# sourceMappingURL=Theme.js.map